import { render } from "./LeakRulesIndex.vue?vue&type=template&id=d5c9d95c"
import script from "./LeakRulesIndex.vue?vue&type=script&lang=js"
export * from "./LeakRulesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__